/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { observer } from 'mobx-react-lite'
import { useMobxStore } from '../../../state'
import colors from '@sportninja/common/constants/appColors'
import { isCanlan } from '@sportninja/common/utils/customer-name'
import { EventDetails } from './Login'
import dayjs from 'dayjs'

export const EventCard = ({ eventInfo, isDarkMode }) => {
  return (
    <div
      css={css`
        background-color: ${isDarkMode ? '#33363B' : '#f5f5f5'};
        padding: 16px;
        border-radius: 8px;
        margin-top: 32px;
        display: flex;
        align-items: center;
        gap: 16px;
        color: ${isDarkMode ? colors.WHITE : colors.BLACK};

        @media (max-width: 768px) {
          padding: 16px 0;
        }
      `}
    >
      <div
        css={css`
          max-width: 100px;
          max-height: 100px;
        `}
      >
        <img
          src={eventInfo?.image?.full_path}
          css={css`
            width: 100%;
            height: 100%;
          `}
        />
      </div>
      <div>
        <p>COMPETITION INFO</p>
        <p
          css={css`
            margin: 8px 0;
            font-size: 32px;
            font-weight: 700;
            font-family: ${isCanlan
              ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
              : 'Rift, Arial, Helvetica, sans-serif'};
          `}
        >
          {eventInfo?.name}
        </p>
        <EventDetails
          label='Organization'
          value={eventInfo?.registration?.organization_name}
        />
        <EventDetails
          label='Registration Open'
          value={`${dayjs(eventInfo?.registration?.starts_at)
            .utc()
            .format('MMM D')} - ${dayjs(eventInfo?.registration?.ends_at)
            .utc()
            .format('MMM D, YYYY')} `}
        />
        {eventInfo?.registration?.root_schedule ? (
          <EventDetails
            label='Competition Start'
            value={`${dayjs(eventInfo?.registration?.root_schedule?.starts_at)
              .utc()
              .format('MMM D')} - ${dayjs(
              eventInfo?.registration?.root_schedule?.ends_at
            )
              .utc()
              .format('MMM D, YYYY')} `}
          />
        ) : null}
        {eventInfo?.registration?.location && (
          <EventDetails label='Location' value={eventInfo?.location} />
        )}
      </div>
    </div>
  )
}

export const ConfirmProfile = observer(({ isDarkMode }) => {
  const {
    registrationInvite: {
      state: { eventInfo },
      confirmTeamRepStep,
      confirmPlayerStep,
    },
  } = useMobxStore()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content: center;
      `}
    >
      <h1
        css={css`
          text-align: center;
          margin-top: 32px;
          font-size: 30px;
          font-weight: 700;
          color: ${isDarkMode ? colors.WHITE : colors.HEADER};
          font-family: ${isCanlan
            ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
            : 'Rift, Arial, Helvetica, sans-serif'};
        `}
      >
        Welcome to registration!
      </h1>
      <EventCard eventInfo={eventInfo} isDarkMode={isDarkMode} />
      <p
        css={css`
          text-align: center;
          margin-top: 32px;
          align-self: center;
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          color: ${isDarkMode ? colors.WHITE : colors.HEADER};
        `}
      >
        {"Let's get started by identifying you"}
      </p>
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 32px;
        `}
      >
        <button
          onClick={() => confirmTeamRepStep({ scheduleId: eventInfo?.id })}
          css={css`
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 8px 0;
            margin-right: 8px;
            color: white;
            flex: 1;
            height: 40px;
            background: ${colors.DEFAULT_FLAIR};
            border-radius: 4px;
            font-size: 18px;
            font-weight: 700;
            font-family: ${isCanlan
              ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
              : 'Rift, Arial, Helvetica, sans-serif'};
          `}
        >
          I’M A TEAM OFFICIAL
        </button>
        {eventInfo?.registration?.player_registration_allowed && (
          <button
            onClick={() => confirmPlayerStep({ scheduleId: eventInfo?.id })}
            css={css`
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              padding: 8px 0;
              margin-left: 8px;
              flex: 1;
              height: 40px;
              border: 2px solid #3f4753;
              color: ${isDarkMode ? 'white' : colors.HEADER};
              border-radius: 4px;
              font-size: 18px;
              font-weight: 700;
              font-family: ${isCanlan
                ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
                : 'Rift, Arial, Helvetica, sans-serif'};
            `}
          >
            I’M A PLAYER
          </button>
        )}
      </div>
    </div>
  )
})
